import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Rating } from '../rating/rating.component';
import { Valoration } from '../valoration/valoration.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { Page } from '@core/services';
import { Router, RouterModule } from '@angular/router';
import { IHomeTop10 } from '@core/models';
import { CdnUrlPipe } from '@shared/pipes';
import { getRandomObjectsInRangeSync, StringUtil } from '@shared/utils';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-top-ten-random',
  imports: [TranslateModule, Rating, Valoration, LazyLoadImageModule, CdnUrlPipe, RouterModule],
  templateUrl: "./top-ten-random.component.html",
  styleUrl: "./top-ten-random.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopTenRandom implements OnInit {
  private readonly pageService = inject(Page);
  private readonly router = inject(Router);

  /** Varibale que guardara la cantidad de geomarcadores que aparecerán, este dato llega desde un componente padre*/
  readonly quantity = input.required<number>();
  /** Variable que guardara la lisa de geomarcadores*/
  private topTenList!: IHomeTop10[];
  /** Variable que guardara la lisa de geomarcadores*/
  protected readonly topTenRandom = signal<IHomeTop10[]>([]);

  constructor() {}

  /**
   * Función nativa de angular que se activa despues del constructor, en este caso se utiliza asincronamente para inicializar la
   * variable topTenlist con lo que retorna el metodo getTopTen() y con esto inicializa la varible topTenRandom.
   */
  async ngOnInit() {
    this.topTenList = await this.getTopTen();
    const topTenRandom = getRandomObjectsInRangeSync(
      this.topTenList,
      this.quantity(),
      0,
      this.topTenList.length - 1
    );
    this.topTenRandom.set(topTenRandom);
  }

  /**
   * Función que obtiene la lista de elementos que pertenecen o se encuntran en los top10 de la app web.
   * @returns Retorna un promesa con los geomarcadores que estan en el top.
   */
  private getTopTen(): Promise<Array<IHomeTop10>> {
    return lastValueFrom(this.pageService.topTen());
  }

  /**
   * Función encargada de redirigir al usuario a la vista del top 10 especififcado a traves de la variable title.
   * @param title Parametro que contiene la información del top al cual debe dirigirse.
   */
  protected goToTopten(title: string) {
    this.router.navigate([`topten/${StringUtil.slugify(title)}`]);
  }
}
